import { render, staticRenderFns } from "./ServiceWarehouseItemsForm.vue?vue&type=template&id=2c815bec&"
import script from "./ServiceWarehouseItemsForm.vue?vue&type=script&lang=js&"
export * from "./ServiceWarehouseItemsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
